import { useFormik } from 'formik';
import { createTransactionValidationSchema } from '../../const/createTransactionValidationSchema';
import { Box } from '@/components/Box/Box';
import { ResponseErrorType } from '@/types/sharedTypes';
import { FormikDatePicker } from '@/components/form/fields/FormikDatePicker/FormikDatePicker';
import { FormikForm } from '@/components/form/FormikForm/FormikForm';
import { FormikInput } from '@/components/form/fields/FormikInput/FormikInput';
import { Button } from '@/components/Button/Button';
import { SubmitEvent } from 'react';
import { ValuesType } from '@/bundle/_OrgAdmin/TransactionsPage';
import { getResponseError } from '@/helpers/apiHelpers/responseHelpers';
import { Notification } from '@/components/Notification/Notification';
import { FieldRow } from '@/components/form/FieldRow/FieldRow';

type CreateTransactionFormType = {
  onCreate: (values: ValuesType) => void;
  apiError: ResponseErrorType;
  onClose: () => void;
  isLoading: boolean;
};

export const CreateTransactionForm = ({ onCreate, apiError, onClose, isLoading }: CreateTransactionFormType) => {
  const formik = useFormik({
    initialValues: {
      name: '',
      expected_close_date: '',
    },
    validationSchema: createTransactionValidationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      onCreate(values);
    },
  });

  const saveHandler = (e: SubmitEvent<HTMLFormElement>) => {
    formik.handleSubmit(e);
  };

  const formError = getResponseError(apiError);

  return (
    <Box width='100%'>
      {formError && (
        <Notification variant='error' marginBottom='16px'>
          {formError}
        </Notification>
      )}

      <FormikForm value={formik}>
        <FormikInput
          label='Transaction Name*'
          placeholder='Enter Transaction Name'
          name='name'
          autoFocus
          apiError={apiError}
        />
        <FieldRow columns={[7, 5]}>
          <FormikDatePicker
            name='expected_close_date'
            label='Expected Closing Date'
            placeholder='Select Date'
            apiError={apiError}
          />
        </FieldRow>
        <Box
          columnGap='20px'
          rowGap='20px'
          display='flex'
          marginTop='14px'
          flexDirection='row'
          mobile={{ flexDirection: 'column-reverse' }}
        >
          <Button variant='secondary' mobileStretch onClick={onClose} width={200} type='button'>
            Cancel
          </Button>
          <Button onClick={saveHandler} mobileStretch type='submit' width={200} isLoading={isLoading}>
            Save
          </Button>
        </Box>
      </FormikForm>
    </Box>
  );
};
